<template>
<div class="page-favorites">
	<div class="product-added--overlay" v-show="itemAdded">
		<div class="container">
			<div class="product-added--overlay-wrapper">
				<img src="/images/icons/ic-notification.svg" alt="Notification" title="Notification" class="icon">
				<p><span v-text="productName"></span>&nbsp;-&nbsp;<strong>{{ $__('profile.favorites.added_to_bag') }}</strong> <button class="btn btn-sm btn-primary btn-view-cart" @click="showCart">{{ $__('profile.favorites.view_cart')}}</button></p>
				<button class="btn btn-plain btn-close" @click="addedClose">
					<svg slot="close" class="ticon"><use xlink:href="/images/icons.svg#icon-close"></use></svg>
				</button>
			</div>
		</div>
	</div>

	<table v-if="favorites.length > 0" class="table cart-table">
		<tbody>

			<tr v-for="(favorite, index) in dataFavorites" :key="favorite.id">
				<td class="cart-table--picture">
					<img loading="lazy" :src="favorite.picture" class="img-fluid" :alt="favorite.title">
				</td>
				<td class="cart-table--title">
					<div class="row">
						<div class="col-9 title">
							<h6 v-text="favorite.title"></h6>
							<span class="price-per-item" v-html="$__('page.price.peritem')">
							</span>
							<span v-html="formatPrice(favorite.price)"></span>
							<span class="category" v-text="favorite.category.title"></span>
						</div>
						<div class="col-auto ml-auto prices">

							<div class="price-sum" v-html="formatPrice(favs[favorite.id])"></div>
						</div>
					</div>
					<div class="row actions">
						<div class="col-auto amount">
							<span v-text="$__('cart.table.quantity')"></span>
							<vue-numeric-input
								align="center"
								:value="1"
								:min="1"
								:step="1"
								@input="updateItems($event, favorite.id, favorite.price, index)"></vue-numeric-input>
						</div>
						<div class="col-auto ml-auto">
							<button class="btn btn-plain btn-buy" @click="addToCart(index, favoritesEecItems[favorite.id])">{{ $__('profile.favorites.add_to_bag') }}</button>
						</div>
						<div class="col-auto remove">
							<button type="button" class="btn btn-plain cart-remove-button ml-auto" @click="removeFromFavorites(favorite, index)">
								<svg class="ticon"><use xlink:href="/images/icons.svg#icon-x-circle"></use></svg>
							</button>
						</div>
					</div>
				</td>
			</tr>
		</tbody>
	</table>
	<p v-else v-html="$__('profile.favorites.empty')"></p>

</div>

</template>

<script>
import VueNumericInput from 'vue-numeric-input';

export default {
	name: "FavoriteList",
	props: {
		favorites: {
			type: Array,
			default: []
		},
		favoritesEecItems: {
			type: Array|Object,
			default: () => ({})
		}
	},
	components: {
		VueNumericInput
	},
	data() {
		return {
			favs: [],
			dataFavorites: this.favorites,
			itemAdded: false,
			productName: ''
		}
	},

	methods: {

		// Update pricing
		updateItems(items, fav, price, index) {
			let newPrice = items * price;
			this.$set(this.favs, fav, newPrice)

			this.dataFavorites[index].quantity = items;
		},

		formatPrice (price) {
			return numbro(parseFloat(price)).formatCurrency();
		},

		addedClose () {
			this.itemAdded = false;
		},

		showCart() {
			this.$root.$refs.CartHeader.openCart();
		},

		// Remove from favorites
		removeFromFavorites(product, index) {
			this.dataFavorites.splice(index,1);
			console.log(product);

			axios.post(`/favorite/remove/${product.id}`)
				.then(response => {
					console.log(response);
				})
				.catch(response => {

				});
		},
		async addToCart(index, payload) {
			this.itemAdded = true;
			this.productName = this.dataFavorites[index].title;

			this.$store.dispatch('cart/addToCart', {
				product: this.dataFavorites[index].id,
				amount: this.dataFavorites[index].quantity
			}).then(res => {});

			// Add amount
			payload.quantity = this.dataFavorites[index].quantity

			window.dataLayer.push({'event_params': null, 'ecommerce': null});
			window.dataLayer.push({
				'event': 'RO_event_EEC',
				'event_params': {
					'gtm_name': 'EEC_add_to_cart',
				},
				'ecommerce': {
					'currency': global.current_currency,
					'items': [payload].map(item => {
						Object.keys(item).forEach(attribute => {
							if (item[attribute] === 'undefined') {
								item[attribute] = undefined
							}
							if (item[attribute] === '') {
								item[attribute] = undefined
							}
						})
						return item
					})
				},
			});
		},
	},
	created() {
		this.favorites.forEach(item => {
			this.favs[item.id] = item.price;
		});
	},
	mounted() {
		this.dataFavorites.forEach((favorite, index) => {
			this.dataFavorites[index].quantity = 1;
		})
	}
}
</script>
